import { Caption, SearchInput, SearchInputTypes, HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

interface IsNotClosedProps {
  searchInputProps: SearchInputTypes.Props;
  children: React.ReactNode;
  isMobile: boolean;
}

export const IsNotClosed: React.FC<IsNotClosedProps> = ({
  searchInputProps,
  children,
  isMobile,
}) => {
  return (
    <VStack space={{ base: Spacing['inline.xxs'] }} px={{ base: 0, sm: Spacing['inline.xxs'] }}>
      <HStack alignItems="center" justifyContent="space-between">
        <SearchInput {...searchInputProps} />
      </HStack>
      {!isMobile && (
        <HStack alignItems="center" space={Spacing['inline.xxs']}>
          <Caption
            testId="qualified-client-legend"
            icon="QualifiedClient"
            iconSize="xs"
            text="Investidor qualificado"
            iconColor={Color['brand.secondary.principal']}
          />
          <Caption
            testId="professional-investor-legend"
            icon="ProfessionalInvestor"
            text="Investidor profissional"
            iconSize="xs"
            iconColor={Color['brand.tertiary.principal']}
          />
        </HStack>
      )}
      {children}
    </VStack>
  );
};
